import { lockScroll, unlockScroll } from '@theme/scroll-lock';

function initMobileSearchDrawer() {
  const drawer = document.getElementById('mobile-search-drawer');
  if (!drawer) return;

  const body = document.body;
  const backdrop = drawer.querySelector('[data-search-drawer-backdrop]');
  const closeBtn = drawer.querySelector('[data-search-drawer-close]');
  const form = drawer.querySelector('[data-search-drawer-form]');
  const input = drawer.querySelector('[data-search-drawer-input]');
  const clearBtn = drawer.querySelector('[data-search-drawer-clear]');
  const submitBtn = drawer.querySelector('[data-search-drawer-submit]');
  const resultsEl = drawer.querySelector('[data-search-drawer-results]');
  let debounceTimer = null;

  function openDrawer() {
    if (drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }
    lockScroll();
    body.classList.add('search-drawer-open');
    drawer.classList.remove('is-hidden');
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    if (input) input.value = '';
    toggleIcons();
    loadRecentlyViewed();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    setTimeout(() => {
      drawer.classList.add('is-hidden');
      body.classList.remove('search-drawer-open');
      unlockScroll();
    }, 300);
  }

  function toggleIcons() {
    const active = input && (input.value.trim().length > 0 || document.activeElement === input);
    if (clearBtn) {
      if (active) clearBtn.classList.remove('is-hidden');
      else clearBtn.classList.add('is-hidden');
    }
    if (submitBtn) {
      if (active) submitBtn.classList.add('is-hidden');
      else submitBtn.classList.remove('is-hidden');
    }
  }

  function refreshDrawerResultPrices() {
    document.dispatchEvent(new CustomEvent('theme:convert-prices'));
  }

  async function loadRecentlyViewed() {
    if (!resultsEl) return;
    resultsEl.innerHTML = '<div class="mobile-menu-drawer__recently-title">Recently Viewed</div><div class="mobile-menu-drawer__search-loading">Loading…</div>';

    try {
      const viewedProducts = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
      if (viewedProducts.length === 0) {
        resultsEl.innerHTML = '<div class="mobile-menu-drawer__recently-title">Recently Viewed</div><div class="mobile-menu-drawer__search-no-results">No recently viewed products</div>';
        return;
      }

      const searchQuery = viewedProducts.slice(0, 8).map((id) => `id:${id}`).join(' OR ');
      const url = new URL('/search/suggest', window.location.origin);
      url.searchParams.set('q', searchQuery);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '8');
      url.searchParams.set('resources[options][fields]', 'title,product_type,tag,variants.title,variants.sku,variants.barcode,vendor');
      url.searchParams.set('resources[options][search_by]', 'fields');
      url.searchParams.set('section_id', 'mobile-drawer-search');

      const res = await fetch(url.toString());
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const block = doc.querySelector('[data-search-results]');

      if (block && block.innerHTML.trim()) {
        resultsEl.innerHTML = block.innerHTML;
        refreshDrawerResultPrices();
      } else {
        resultsEl.innerHTML = '<div class="mobile-menu-drawer__recently-title">Recently Viewed</div><div class="mobile-menu-drawer__search-no-results">No recently viewed products</div>';
      }
    } catch (err) {
      resultsEl.innerHTML = '<div class="mobile-menu-drawer__recently-title">Recently Viewed</div><div class="mobile-menu-drawer__search-no-results">Error loading products</div>';
    }
  }

  async function runSearch(q) {
    if (!resultsEl) return;
    resultsEl.innerHTML = '<div class="mobile-menu-drawer__search-loading">Searching…</div>';

    try {
      const url = new URL('/search/suggest', window.location.origin);
      url.searchParams.set('q', q);
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[type]', 'product,query');
      url.searchParams.set('resources[options][fields]', 'title,product_type,tag,variants.title,variants.sku,variants.barcode,vendor');
      url.searchParams.set('resources[options][search_by]', 'fields');
      url.searchParams.set('section_id', 'mobile-drawer-search');

      const res = await fetch(url.toString());
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const block = doc.querySelector('[data-search-results]');

      if (block && block.innerHTML.trim()) {
        const inner = block.innerHTML;
        resultsEl.innerHTML = inner;
        refreshDrawerResultPrices();
      } else {
        resultsEl.innerHTML = '<div class="mobile-menu-drawer__search-no-results">No results</div>';
      }
    } catch (err) {
      resultsEl.innerHTML = '<div class="mobile-menu-drawer__search-no-results">Error loading results</div>';
    }
  }

  clearBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    if (input) {
      input.value = '';
      input.focus();
      toggleIcons();
      loadRecentlyViewed();
    }
  });

  input?.addEventListener('focus', toggleIcons);
  input?.addEventListener('blur', toggleIcons);
  input?.addEventListener('input', () => {
    toggleIcons();
    const q = (input.value || '').trim();
    if (q.length < 2) {
      loadRecentlyViewed();
      return;
    }
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => runSearch(q), 250);
  });

  closeBtn?.addEventListener('click', closeDrawer);
  backdrop?.addEventListener('click', closeDrawer);

  drawer.addEventListener('click', (e) => {
    if (e.target.closest('[data-clear-recent]')) {
      e.preventDefault();
      localStorage.removeItem('viewedProducts');
      loadRecentlyViewed();
    }
  });

  document.querySelectorAll('[data-mobile-search-open]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });
  });

  window.openMobileSearchDrawer = openDrawer;
  window.closeMobileSearchDrawer = closeDrawer;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileSearchDrawer, { once: true });
} else {
  initMobileSearchDrawer();
}
